<fieldset class="square-big">
    <legend class="square-legend">
        {{ key | translate }}
        <app-tooltip message="{{ key + '-hint' | translate }}" position="bottom"></app-tooltip>
    </legend>
    <div class="square-value">
        {{ value | localizedNumber : format }}<ng-container *ngIf="isCurrency">€</ng-container>
    </div>
</fieldset>
